function changeFileName(file: File, fileName: string) {
  const blob = file.slice(0, file.size, file.type);

  return new File([blob], fileName, { type: file.type });
}

export default changeFileName;
